import framework from 'utils/framework';
import { useEffect } from 'react';
const { wrapFunctionalComponent } = framework;

import urlUtils from 'utils/Url';

const AddPhoto = () => {
    useEffect(() => {
        urlUtils.redirectTo('/community/gallery?upload=true');
    }, []);

    return null;
};

export default wrapFunctionalComponent(AddPhoto, 'AddPhoto');
